// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"18":"product","177":"home","209":"transaction","443":"about"}[chunkId] + "." + {"18":"00bb2405","177":"8681af1a","209":"d64b71cf","443":"ab287be6"}[chunkId] + ".css";
};